import { defaultLogoUrl } from "../../../helpers/defaultUrls";
import { useFilestackImageUrl } from "../../../hooks/useFilestackImageUrl";

const MAX_LOGO_WIDTH = 570;
const DEFAULT_LOGO_HANDLE_TOKEN = "default-smartsuite-logo";

export const useLogoUrl = (logo?: string | null): string | null => {
  // The new editor sends "" as an explicit "logo removed" marker. Legacy forms send
  // null/undefined and still get the default SmartSuite logo. The special token also
  // resolves to the default logo. Bypass filestack for both marker values.
  const isRemovalMarker = logo === "";
  const isDefaultMarker = logo === DEFAULT_LOGO_HANDLE_TOKEN;
  const resolved = useFilestackImageUrl(isRemovalMarker || isDefaultMarker ? null : logo, {
    width: MAX_LOGO_WIDTH,
    defaultUrl: defaultLogoUrl,
  });

  if (isRemovalMarker) return null;
  return resolved;
};
